import React from "react";
import usePushSubscribe from "./pushSubscribe-hook";
import { ButtonTypes } from "../../../../../../Interfaces/componentTypes";
import Button from "../../../../../../Components/Button/button";
import useLanguagesHooks from "../../../../../../Components/Languages/setLanguage-hooks";
import { Orders } from "../../../../../../Assets/Icons";
import styles from "./pushSubscribe.module.scss";

interface IProps {
    companyId: number;
    onClose: () => void;
}

const PushSubscribeDialog: React.FC<IProps> = ({ companyId, onClose }) => {
    const { t } = useLanguagesHooks();
   const {loading,onReject,handleSubscribe} = usePushSubscribe(companyId,onClose);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <img src={Orders} alt='orders.svg'/>
                <p>{t('My_Business.Push_Sub.Title')}</p>
            </div>
            <div className={styles.content}>
                <div className={styles.description}>
                    <p>{t('My_Business.Push_Sub.Text')}</p>
                </div>
                <div className={styles.buttonRow}>
                    <Button
                        buttonType={ButtonTypes.Secondary}
                        title={t('My_Business.Push_Sub.Reject')}
                        onClick={onReject}
                        buttonTitleStyle={styles.buttonTitle}
                    />
                    <Button
                        buttonType={ButtonTypes.Primery}
                        title={t('My_Business.Push_Sub.Confirm')}
                        onClick={handleSubscribe}
                        buttonStyle={styles.button}
                        buttonTitleStyle={styles.buttonTitle}
                        isLoading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default PushSubscribeDialog;



